'use client';

import { ProgressProvider } from '@bprogress/next/app';

const Providers = ({ children }: { children: React.ReactNode }) => {

    return (
        <ProgressProvider
            height="4px"
            color="#cead8e"
            options={{ showSpinner: true }}
            shallowRouting
        >
            {children}
        </ProgressProvider>
    );
};

export default Providers;